import { useMediaQuery } from "@mui/material";
import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { FaRegUser } from "react-icons/fa";

import { LoyaltyProduct } from "../../api/types/account.type";
import { SocialSignUpType } from "../../api/types/social.type";
import { FidelityTranslations } from "../../api/types/translations";
import { translationsContent } from "../../localization/translations";
import { useLanguage } from "../../store/lang.context";
import { useUser } from "../../store/user.context";
import imageLoader from "../../utils/loader";
import { translate } from "../../utils/translate";
import Login from "../auth/Login";
import Signup from "../auth/Signup";
import SocialSignUp from "../auth/SocialSignup";
import DietPortionComponent, {
  ColorsType,
} from "../Homepage/Fidelity/DietPortion/dietPortionSection";
import classes from "./club.module.scss";
import Intro from "./Intro";

interface Props {
  translations: FidelityTranslations[];
  products: LoyaltyProduct[];
}
type DietInstanceType = {
  number: number;
  titleKey: keyof typeof translationsContent;
  description: keyof typeof translationsContent;
  image1: string;
  image2: string;
  image3?: string;
  color: ColorsType;
  accesory?: string;
  star?: string;
};
const dietInstances: DietInstanceType[] = [
  {
    number: 12,
    titleKey: "dietSection1",
    description: "dietSection2",
    image1: "bread.png",
    image2: "yogurt.png",
    color: "GREEN1",
  },
  {
    number: 36,
    titleKey: "dietSection1",
    description: "dietSection3",
    image1: "crepe.png",
    image2: "water.png",
    color: "GREEN2",
  },
  {
    number: 60,
    titleKey: "dietSection1",
    description: "dietSectionFour",
    image1: "cofee.png",
    image2: "sugar.png",
    color: "GREEN3",
  },
  {
    number: 120,
    titleKey: "dietSection1",
    description: "dietSectionFive",
    image1: "pasta.png",
    image2: "water.png",
    image3: "sugar.png",
    color: "GREEN4",
    accesory: "ou",
  },
  {
    number: 132,
    titleKey: "dietSection1",
    description: "dietSectionSix",
    image1: "pasta.png",
    image2: "water.png",
    image3: "sugar.png",
    color: "GREEN5",
    accesory: "&",
  },
  {
    number: 152,
    star: "*",
    titleKey: "dietSection1",
    description: "dietSectionSeven",
    image1: "pasta.png",
    image2: "water.png",
    image3: "sugar.png",
    color: "GREEN6",
    accesory: "&",
  },
];

const LeClub = ({ translations }: Props) => {
  const [loginModalIsOpen, setLoginModalIsOpen] = useState(false);
  const [socialLoginModalIsOpen, setSocialLoginModalIsOpen] =
    useState<SocialSignUpType>({
      id: 0,
      open: false,
    });
  const [signupModalIsOpen, setSignupModalIsOpen] = useState(false);

  const openLoginPopup = () => {
    setLoginModalIsOpen(true);
  };

  const [scrollValue, setScrollValue] = useState(0);

  const router = useRouter();

  const { language } = useLanguage();
  const { user } = useUser();

  const isMobile = useMediaQuery("(max-width: 1080px)");

  // eslint-disable-next-line unused-imports/no-unused-vars
  const listenScrollEvent = (e: Event) => {
    if (isMobile) return setScrollValue(window.scrollY);
  };

  const handleGoToAccountFidelity = () => {
    if (!user) {
      setLoginModalIsOpen(true);
      return;
    }
    router.push(translate(translationsContent, "accountHeader2", language));
  };

  useEffect(() => {
    if (isMobile) {
      window.addEventListener("scroll", listenScrollEvent);
      return () => window.removeEventListener("scroll", listenScrollEvent);
    } else {
      return () => {};
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  return (
    <>
      {loginModalIsOpen && (
        <Login
          setLoginIsOpen={setLoginModalIsOpen}
          setSignUpIsOpen={setSignupModalIsOpen}
          setSocialSignUp={setSocialLoginModalIsOpen}
        />
      )}
      {socialLoginModalIsOpen.open && (
        <SocialSignUp
          setSignUpIsOpen={setSignupModalIsOpen}
          setLoginIsOpen={setLoginModalIsOpen}
          socialSignUp={socialLoginModalIsOpen}
          setSocialSignUp={setSocialLoginModalIsOpen}
        />
      )}
      {signupModalIsOpen && (
        <Signup
          setLoginIsOpen={setLoginModalIsOpen}
          setSignUpIsOpen={setSignupModalIsOpen}
          setSocialSignUp={setSocialLoginModalIsOpen}
        />
      )}
      <Intro translations={translations} />

      <div className={classes.bulletPointsContainer}>
        <div className={classes.titleText}>
          {translate(translationsContent, "fideliteTitleText", language)}
        </div>
        {/* <div className={classes.separatorLineOne}></div> */}
        <div className={classes.bulletPointContainer}>
          <div className={classes.bulletPoint1}>
            <div className={classes.bulletParts1}>
              <div className={classes.bulletnumber1}>
                <img src={`/assets/ui/number${1}.jpg`} alt={"number1"} />
              </div>
              <div className={classes.number1Text}>
                {translate(
                  translationsContent,
                  "fideliteBulletPoint1part1",
                  language
                )}
                <FaRegUser />
                <br />
                <span>
                  {translate(
                    translationsContent,
                    "fideliteBulletPoint1part3",
                    language
                  )}
                </span>
                <span className={classes.linkStyle} onClick={openLoginPopup}>
                  {translate(
                    translationsContent,
                    "fideliteBulletPoint1part2",
                    language
                  )}
                </span>
              </div>
            </div>
          </div>

          <div className={classes.bulletPoint2}>
            <div className={classes.bulletnumber2}>
              <img src={`/assets/ui/number${2}.jpg`} alt={"number2"} />
            </div>
            <div>
              {translate(translationsContent, "fideliteBulletPoint2", language)}
            </div>
          </div>
          <div className={classes.imageContainer}>
            <Image
              src="euroUpdated.png"
              loader={imageLoader}
              height={190}
              width={290}
            />
          </div>
          <div className={classes.instancesContainer}>
            {dietInstances.map((instance, index) => (
              <DietPortionComponent
                key={index}
                number={instance.number}
                titleKey={instance.titleKey}
                description={instance.description}
                image1={instance.image1}
                image2={instance.image2}
                image3={instance.image3}
                color={instance.color}
                accessory={instance.accesory}
                star={instance.star}
              />
            ))}
          </div>
          <div className={classes.noteContainer}>
            {translate(translationsContent, "fideliteNoteText", language)}
          </div>
          <div className={classes.bulletPoint3}>
            <div className={classes.bulletnumber3}>
              <img src={`/assets/ui/number${3}.jpg`} alt={"number3"} />
            </div>
            <div>
              {translate(translationsContent, "fideliteBulletPoint3", language)}
            </div>
            <div className={classes.iphoneContainer}>
              <Image
                src="fidelityiphone.png"
                loader={imageLoader}
                height={300}
                width={300}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={classes.registerButtonContainer}>
        <button className={classes.registerButton} onClick={openLoginPopup}>
          {translate(translationsContent, "buttonContent", language)}
        </button>
        {loginModalIsOpen && (
          <Login
            setLoginIsOpen={setLoginModalIsOpen}
            setSignUpIsOpen={setSignupModalIsOpen}
            setSocialSignUp={setSocialLoginModalIsOpen}
          />
        )}
        {socialLoginModalIsOpen.open && (
          <SocialSignUp
            setSignUpIsOpen={setSignupModalIsOpen}
            setLoginIsOpen={setLoginModalIsOpen}
            socialSignUp={socialLoginModalIsOpen}
            setSocialSignUp={setSocialLoginModalIsOpen}
          />
        )}
        {signupModalIsOpen && (
          <Signup
            setLoginIsOpen={setLoginModalIsOpen}
            setSignUpIsOpen={setSignupModalIsOpen}
            setSocialSignUp={setSocialLoginModalIsOpen}
          />
        )}
      </div>
      <div className={classes.fideliteLastText}>
        {translate(translationsContent, "fideliteLastText", language)}
      </div>

      <div className={classes.SaladContainer} />
    </>
  );
};

export default LeClub;
